import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import MuffinRating from "../MuffinRating";
import { BOOKS } from "@/data";

const genreClass = {
    Fantasy: "badge-fantasy",
    Fantascienza: "badge-fantascienza",
};

export default function LibriLetti() {
    return (
        <div className="grid md:grid-cols-2 gap-5" data-testid="books-grid">
            {BOOKS.map((b, i) => (
                <motion.article
                    key={b.id}
                    className="parchment-card p-5 sm:p-6 flex gap-4"
                    initial={{ opacity: 0, y: 22 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.5, delay: (i % 2) * 0.07 }}
                    data-testid={`book-card-${b.id}`}
                >
                    <div className="shrink-0 w-12 h-12 rounded-full border border-[#b08d57]/60 bg-[rgba(176,141,87,0.14)] flex items-center justify-center text-[#7a5a2e]">
                        <b.icon size={22} strokeWidth={1.5} />
                    </div>
                    <div className="flex-1 min-w-0 flex flex-col">
                        <h3 className="f-title text-lg leading-snug text-[#3f2a12]">{b.title}</h3>
                        <p className="f-body italic text-[#6d5638] mt-1 text-sm sm:text-base">{b.by}</p>
                        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-auto pt-4">
                            <span className={`badge ${genreClass[b.genre]}`}>{b.genre}</span>
                            <span className="f-detail text-sm text-[#7a5a2e] flex items-center gap-1.5">
                                <CalendarDays size={13} /> {b.date}
                            </span>
                            <MuffinRating value={b.rating} testid={`muffin-${b.id}`} />
                        </div>
                    </div>
                </motion.article>
            ))}
        </div>
    );
}
